export class BlockedError extends Error {
  name = "BlockedError";

  constructor(errors) {
    super();
    // Yuck. but aligns with existing access/usage
    this.errors = errors;
  }
}
